export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';

export const registerSuccess = () => ({
    type: REGISTER_SUCCESS,
});
